export default {
    baseStyle: {
        title: {
            fontFamily: 'UniversLTStd, Arial, sans-serif',
            fontSize: {base: '14px', sm: '18px'},
            color: 'black',
            textTransform: 'uppercase',
            lineHeight: {base: '18px', sm: 'unset'},
            border: 'none!important'
        },
        edit: {
            color: 'gray.550',
            background: 'none',
            height: '100%',
            padding: 0,
            fontSize: {base: '12px', sm: '14px'},
            fontWeight: 400,
            display: 'flex',
            alignItems: 'center',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            _hover: {
                textDecoration: 'underline',
                color: 'gray.550'
            },
            _active: {
                background: 'none'
            },
            _focus: {
                background: 'none',
                boxShadow: 'none'
            }
        },
        otherDeliveryCheck: {
            fontWeight: 700
        }
    }
}
